import { Box } from '@/components';
import type { FC } from 'react';

type Props = {
  text: string | number;
  width?: string | number;
  align?: 'left' | 'center' | 'right';
  paddingHorizontal?: 'small' | 'medium';
};

const paddingHorizontalMap = {
  small: 1,
  medium: 2,
};

export const TextCell: FC<Props> = ({
  text,
  width,
  align,
  paddingHorizontal,
}) => {
  return (
    <Box width={width} height="100%" display="flex" alignItems="center">
      <p
        style={{
          width: '100%',
          margin: 0,
          padding: `4px ${paddingHorizontalMap[paddingHorizontal ?? 'medium']}px`,
          lineHeight: 1.25,
          fontSize: 7,
          wordBreak: 'break-all',
          whiteSpace: 'pre-wrap',
          textAlign: align ?? 'left',
        }}
      >
        {text}
      </p>
    </Box>
  );
};
